import React, { FC, useCallback } from 'react';
import cn from 'classnames';
import { ExareStatus } from '@websky/graphql';
import { useTheme } from '../../../../../theme';
import { useTranslation } from 'react-i18next';
import { CdnIcon } from '@shared/ui';

interface Props {
	className?: string;
	status: ExareStatus;
	ns?: string;
}

const ExchangeRefundStates: FC<Props> = ({ className, status, ns = 'Refund' }) => {
	const { t } = useTranslation(ns);

	const { ExchangeRefundStates: css } = useTheme('Entities').Order;

	const renderStatesIcon = useCallback(() => {
		switch (status) {
			case ExareStatus.InProcess:
			case ExareStatus.AwaitingPayment:
			case ExareStatus.NeedConfirm:
			case ExareStatus.TimelimitExpired:
				return <CdnIcon icon="Info/Time" />;

			case ExareStatus.Finished:
				return <CdnIcon icon="Info/Item Icluded" />;

			case ExareStatus.Rejected:
			case ExareStatus.Refused:
				return <CdnIcon icon="Info/Not included" />;
		}
	}, [status]);

	return (
		<div className={cn(css.root, className, css[status])}>
			<div className={css.icon}>{renderStatesIcon()}</div>
			<span className={css.text}>{t(status)}</span>
		</div>
	);
};

export default ExchangeRefundStates;
